<template>
  <div class="body">
    <van-nav-bar v-if="!isWxMini" title="支付协议" left-arrow @click-left="onClickLeft">
      <template #left>
        <van-icon name="arrow-left" color="#666666" />
      </template>
    </van-nav-bar>
    <div class="content">
      <div class="agreement" v-html="h"></div>
    </div>
  </div>
</template>

<script>
import { getAgreement } from '@/api/ePayPro.js'
import isWxMini from "@/utils/isWechat.js";
export default {
  components: {
  },
  data() {
    return {
      h: ''
    }
  },
  created() {
    const info = {
      type: ''
    }
    const type = this.$route.query.type
    if (type === '1') {
      info.type = 1
    } else if (type === '3') {
      info.type = 2
    } else if (type === '2') {
      info.type = 3
    }
    console.log(info)
    getAgreement(info).then((res) => {
      this.h = res.result.agreement
    })
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1)
    }
  },
}
</script>

<style lang="scss" scoped>
.content {
  body {
    font-size: 26px;
    font-family: "微软雅黑", Arial, Helvetica, sans-serif;
  }
  body input,
  select,
  textarea {
    font-family: "微软雅黑";
    vertical-align: middle;
  }
  body a,
  input {
    outline: none;
  }
  a:hover {
    text-decoration: underline;
  }
  * {
    margin: 0;
    padding: 0;
    border: 0;
  }
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-weight: normal;
    font-size: 26px;
  }
  table {
    border-collapse: collapse;
  }
  li {
    display: inline;
    list-style: none;
  }
  a {
    text-decoration: none;
    color: #444;
  }
  a:hover {
    text-decoration: underline;
  }

  /deep/.xyzt {
    width: 100%;
    margin: 0 auto;
  }
  /deep/.dbt {
    font-size: 26px;
    font-weight: bold;
    text-align: center;
  }
  /deep/.xbt {
    font-size: 26px;
    font-weight: bold;
    margin-top: 20px;
  }
  /deep/.xbt2 {
    font-weight: bold;
  }
  /deep/.xytext {
    font-size: 26px;
    margin-top: 20px;
    line-height: 45px;
  }
  /deep/.xytext2 {
    font-size: 26px;
    margin-top: 5px;
    line-height: 45px;
  }
  .agreement {
    background-color: #fff;
    padding: 30px 40px;
    color: #333;
  }
}
</style>
